import { cn } from '@neo/lib/utils'
import { domAnimation, LazyMotion, m, useReducedMotion } from 'framer-motion'
import type { FC, ReactNode } from 'react'
import { EASE, FADE_S, POP, POP_IN, useHasMounted } from './motion'

/**
 * Brings in what replaced the last `id`, popping or fading in over the old; `highlight` tints it for
 * a moment. Not on first show, unless `isNew` (it mounted with what it marks).
 */
export const ChangeIn: FC<{
  id: string
  pop?: boolean
  highlight?: boolean
  isNew?: boolean
  block?: boolean
  className?: string
  children: ReactNode
}> = ({ id, pop, highlight, isNew, block, className = 'flex', children }) => {
  const isChange = useHasMounted() || isNew
  const isStatic = useReducedMotion()
  const Tag = block ? m.div : m.span
  return (
    <LazyMotion features={domAnimation}>
      <Tag
        key={id}
        className={cn(highlight && 'relative isolate', className)}
        initial={isChange ? (pop && !isStatic ? POP_IN : { opacity: 0 }) : false}
        animate={{ scale: 1, opacity: 1 }}
        transition={pop ? POP : { duration: FADE_S, ease: EASE.out }}
      >
        {highlight && (
          <m.span
            className="pointer-events-none absolute -inset-x-1.5 -inset-y-0.5 -z-10 rounded-md bg-brand/10"
            initial={{ opacity: isChange ? 1 : 0 }}
            animate={{ opacity: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: EASE.out }}
            aria-hidden
          />
        )}
        {children}
      </Tag>
    </LazyMotion>
  )
}
